module.exports = __webpack_public_path__ + "static/media/jacket2.37e76f8a.jpg";